import React from "react";
import { PARTNERS_NETWORK } from "../../data/data";

const ESGEcoSystem = () => {
  const [activetab, setActivetab] = React.useState("partners-network");
  const [selectedPartner, setSelectedPartner] = React.useState(PARTNERS_NETWORK[0]);

  const tabs = [
    { key: "partners-network", label: "Partners Network" },
    { key: "climate-alliances", label: "Climate Alliances" },
    { key: "impact", label: "Impact" },
  ];

  const getPartnersToShow = () => {
    if (activetab === "partners-network") return PARTNERS_NETWORK;
    if (activetab === "climate-alliances") return PARTNERS_NETWORK.slice(3, 5);
    if (activetab === "impact") return PARTNERS_NETWORK.slice(2, 7);
    return [];
  };

  return (
    <section className="flex flex-col items-center p-4 dark:bg-[#0F172A] pt-16">
      {/* Header */}
      <div className="text-left md:text-center mb-8">
        <h6 className="text-blue-600 text-base font-medium uppercase mb-2">
          Built on Strong Partnerships
        </h6>
        <h3 className="text-xl md:text-2xl font-semibold dark:text-white">
          We are part of a strong and trusted ESG ecosystem.
        </h3>
      </div>

      {/* Tabs */}
      {/* <div className="flex justify-center gap-4 mb-10 flex-wrap">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActivetab(tab.key)}
            className={`px-5 py-2 rounded-full font-medium transition border ${
              activetab === tab.key
                ? "bg-green-600 text-white"
                : "bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300 hover:bg-green-100 dark:hover:bg-green-800"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div> */}

      {/* Partners Grid */}
      <div className="container">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-4 md:gap-6 mb-12">
          {getPartnersToShow().map((partner) => (
            <div
              key={partner.id}
              // onClick={() => setSelectedPartner(partner)}
              className="flex-shrink-0
          w-20 h-20 md:w-36 md:h-36
          bg-white/80
          rounded-full
          flex items-center justify-center
          shadow-md dark:shadow-gray-700
          transition-all duration-300
          hover:scale-105 hover:shadow-xl p-2"
            >
              <img src={partner.src} alt={partner.id} className="w-auto object-contain
            transition-all duration-300 h-auto object-contain" />
            </div>
          ))}
        </div>

        {/* Partner Details */}
        {/* <div className="bg-white  border dark:bg-slate-900 rounded-3xl shadow-xl p-6 md:p-10 flex flex-col md:flex-row gap-6 transition-all duration-500"> */}
        {/* Left: Person Info */}
        {/* <div className="flex flex-col md:flex-row items-center md:items-start gap-6 md:w-1/2">
            <img
              src={selectedPartner?.person?.image}
              alt={selectedPartner?.person?.name}
              className="w-28 h-28 md:w-32 md:h-32 rounded-full border-4 border-green-200 dark:border-green-600 object-cover"
            />
            <div className="text-center md:text-left">
              <h4 className="text-lg md:text-xl font-semibold text-slate-800 dark:text-white">
                {selectedPartner?.person?.name}
              </h4>
              <p className="text-sm md:text-base text-slate-500 dark:text-slate-400">
                {selectedPartner?.person?.designation}
              </p>
            </div>
          </div> */}

        {/* Right: Partner Logo + Description */}
        {/* <div className="flex-1 flex flex-col justify-between gap-4 md:gap-6">
            <div className="flex justify-center md:justify-start">
              <img
                src={selectedPartner?.src}
                alt={selectedPartner?.id}
                className="w-32 md:w-40 h-auto object-contain"
              />
            </div>
            <p className="text-sm md:text-base text-slate-600 dark:text-slate-300 leading-relaxed mt-4">
              {selectedPartner?.description}
            </p>
          </div> */}
        {/* </div> */}
      </div>
    </section>
  );
};

export default ESGEcoSystem;
